<template>
  <v-container fluid>
    <data_table
      :displayname="'OCTG'"
      :options="false"
      :search_text="search_text"
      :items="ODP_data.Tubular"
      :headers="headers"
      :loader="get_data_load"
      :getPDF_func="$getPDFglobal"
      :pdf_params="pdfparams"
      :type="'Tubular'"
      :defaultSort="'Inspection_Date'"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import data_table from '@/components/data_table.vue'
export default {
  name: 'octg',
  components: { data_table },
  data () {
    return {
      pdfparams: [{ Tubular: '/getoctgPDF' }, 'Order_No'],
      search_text: 'Search (Order No, Ref etc..)',
      search: '',
      headers: [
        { text: 'Order No', align: 'start', sortable: true, value: 'Order_No' },
        { text: 'String No', value: 'String_Number' },
        { text: 'Returned From', value: 'Returned_From' },
        { text: 'Inspection Date', value: 'Inspection_Date' },
        { text: 'Ref', value: 'Ref' },
        { text: 'Quantity', value: 'Quantity' },
        { text: 'Item No', value: 'Item_No' },
        { text: 'Weight', value: 'Weight' },
        { text: 'Grade', value: 'Grade' },
        { text: 'Connection', value: 'Connection' },
        { text: 'Spec', value: 'Spec' },
        { text: 'Equipment', value: 'Equipment' },
        { text: 'PDF', value: 'action', sortable: false }
      ],
      ODP_data: { Tubular: [], BHA: [] }
    }
  },
  computed: {
    ...mapGetters(['getUsername', 'get_data_load'])
  },
  mounted () {
    this.$initialDataLoad(this.$route.meta.backendRoutes, { username: this.$store.getters.getUsername }, 'Inspection_Date')
  },
}
</script>

<style>
</style>
